import { _js } from '@ifixit/localize';
import stepsTemplate from 'ejs/embed/embed.v4.steps.ejs';
import Template from 'Shared/template';

export function StepsController(
   guideData,
   stepSwitcher,
   introController,
   fullScreenController,
   conclusionController,
   prepareEmbed,
   zoom
) {
   let template = prepareEmbed(Template.get(stepsTemplate));
   let container = $('#stepsContainer');

   // Step -1 is effectively the start screen and can't be returned to.
   let index = -1;

   let autoStart = false;

   container.on('click', '.js-next', showNextStep);
   container.on('click', '.js-prev', showPrevStep);

   $(document).keydown(event => {
      switch (event.which) {
         case 39: {
            // Right arrow key
            showNextStep();
            break;
         }
         case 37: {
            // Left arrow key
            showPrevStep();
            break;
         }
      }
   });

   container.on('click', '.js-fullscreen', event => {
      fullScreenController.toggle();
   });

   container.on('click', '.js-operator-fullscreen', event => {
      fullScreenController.toggleParentFullscreen();
   });

   function showNextStep() {
      guideData.get().then(guide => {
         let guideLength = guide.steps.length;
         if (guide.type !== 'teardown') {
            guideLength++;
         }

         // The reason for this is not obvious. Upon loading, TitleController
         // in embed.v4.title.js sets the data capture session iframe back
         // to the intro page by calling "stepsController.showNext()". This
         // call was causing data capture to not start on the correct page.
         if (autoStart) {
            autoStart = false;
         } else {
            showStep(Math.min(index + 1, guideLength));
         }

         // Don't prefetch if we've reached the end of the guide.
         if (index + 2 < guideLength) {
            prefetchStep(Math.min(index + 2, guideLength));
         }
      });
   }

   function setAutoStart(v) {
      autoStart = Boolean(v);
   }

   function getAutoStart() {
      return autoStart;
   }

   function showPrevStep() {
      showStep(Math.max(index - 1, 0));
   }

   function showStep(n) {
      return getStepElement(n)
         .then(element => {
            stepSwitcher.show(element, n);
            index = n;
            const elem = element[0];
            const video = elem.querySelector(`video`);
            if (video) {
               window.setTimeout(() => video.play());
            }
         })
         .done();
   }

   function prefetchStep(n) {
      return getStepElement(n)
         .then(element => {
            stepSwitcher.prefetch(element, n);
         })
         .done();
   }

   function getStepElement(n) {
      // Step 0 == introduction
      if (!n) {
         return introController.getElement();
      }

      return guideData.get().then(constructStep(n));
   }

   function maxStepNumber() {
      return guideData.get().then(guide => guide.steps.length);
   }

   function constructStep(n) {
      return function (guide) {
         let element;
         if (
            n === guide.steps.length + 1 &&
            guide.type !== 'teardown' &&
            guide.conclusion_rendered
         ) {
            element = conclusionController.getElement(guide);
            element.find('.js-next').addClass('disabled');
            return element;
         }

         $('.js-nav-button').removeClass('disabled');

         let step = guide.steps[n - 1];
         step.url = guide.url;
         step.isSingle = true;
         step.isFull = false;
         step.isImage = step.media.type === 'image';
         step.isEmbed = step.media.type === 'embed';
         step.hasMedia = !step.isImage || step.media.data.length > 0;
         step.multipleImages = step.isImage ? step.media.data.length > 1 : false;
         step.pageTitle = step.title === '' ? _js('Step') + ' ' + step.number : step.title;
         step.doesLoop = App.videoLooping ? 'loop' : '';

         element = template(step);

         if (
            n === guide.steps.length &&
            (guide.type === 'teardown' || guide.conclusion_rendered === '')
         ) {
            element.find('.js-next').addClass('disabled');
         }

         if (step.isImage) {
            /**
             * Setup thumbnail hover switching
             */
            let largeImages = element.find('.large > img');
            element.find('.js-thumbnail').mouseenter(function (event) {
               let ndx = $(this).attr('data-index');
               largeImages.hide();
               $(largeImages[ndx]).show();
            });
            largeImages.on('click', zoom);
         } else if (step.isEmbed) {
            let embedEl = element.find('#embed-' + step.stepid)[0];
            embedEl.innerHTML = step.media.data.html;
         } else {
            let videoEl = element.find('#video-' + step.stepid)[0];
            videoEl.setAttribute('controls', true);
         }

         if (!fullScreenController.supported()) {
            element.find('.js-fullscreen').hide();
         }
         return element;
      };
   }

   let self = {
      showNext: showNextStep,
      showStep: showStep,
      maxStepNumber: maxStepNumber,
      getAutoStart: getAutoStart,
   };

   return self;
}
